module.exports = __webpack_public_path__ + "static/media/tickEmpty.904b42fd.svg";